import { Button, Card, css, styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import { bounceUp } from 'assets/styles/animations';
import { VoucherStatus } from 'models';
import LogPattern from 'assets/images/graphic-surprise-perk-flash.png';

const active = theme.palette.primary.main;
const expired = palette.pink[700];
const redeemed = palette.neutral[600];
const expiringSoon = palette.sunshine[500];
const expiringSoonText = palette.blue[500];
const textColor = theme.palette.white;

const statusColours = { active, expired, redeemed };

interface ContentProps {
  status: VoucherStatus;
  alert: string;
}

interface MediaWrapProps {
  surprise: string;
}

export const StyledButton = styled(Button)`
  display: contents;
  line-height: 1;
  text-align: left;

  &:disabled > .MuiPaper-root {
    opacity: 0.8;
  }
`;

export const StyledCard = styled(Card)`
  animation: ${bounceUp} 1s ease-in-out forwards;
  padding: 0;
  user-select: none;
  transition: box-shadow 0.3 ease-in;
  transform: translateY(100vh);
  -webkit-touch-callout: none;

  img {
    -webkit-user-drag: none;
    transition: opacity 0.3s ease-in, transform 0.3s ease-in;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);

    .MuiCardMedia-root {
      transform: scale(1.1);
    }
  }
`;

export const MediaWrap = styled('div')<MediaWrapProps>`
  position: relative;

  ${({ surprise }) =>
    surprise === 'true' &&
    css`
      img {
        min-height: 200px;

        ${theme.breakpoints.up('sm')} {
          min-height: auto;
        }
      }

      div:last-child {
        min-height: 200px;

        ${theme.breakpoints.up('sm')} {
          min-height: 130px;
        }

        ${theme.breakpoints.up('md')} {
          min-height: 176px;
        }
      }
    `}
`;

export const Content = styled('div')<ContentProps>`
  align-items: center;
  background: ${({ status }) => status && statusColours[status]};
  color: ${textColor};
  display: flex;
  height: 46px;
  justify-content: space-between;
  padding: 10px;
  position: relative;
  z-index: 1;
  gap: 10px;

  ${({ alert }) =>
    alert === 'true' &&
    css`
      color: ${expiringSoonText};
      background: ${expiringSoon};
    `}
`;

export const Text = styled(Typography)`
  font-weight: bold;
  line-height: 1.3;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
`;

export const SurprisePerkFlash = styled('div')`
  position: absolute;
  bottom: -1px;
  width: 100%;
  padding: 1.4rem 1rem 1rem;
  z-index: 1;
  background: url(${LogPattern}) top left no-repeat;
  background-size: cover;

  .MuiTypography-root {
    margin: 0;
    color: ${textColor};
    font-size: 24px;
  }
`;

export const ThirdPartyBox = styled('div')`
  position: absolute;
  right: 0;
  z-index: 2;
  top: 10%;
`;
